import { EllipsisVerticalIcon, FlimIcon, FolderIcon } from "assets";
import { CustomTooltip } from "components";
import { forwardRef } from "react";

interface Props {
  clickedFolder: React.MouseEventHandler<HTMLDivElement> | undefined;
  clickedMenu: React.MouseEventHandler<HTMLButtonElement> | undefined;
  title: string;
  description: string | number;
  children: React.ReactNode;
  isepisode?: boolean;
  orderNumber?: number;
}
const FolderCard = forwardRef<HTMLDivElement, Props>(
  (
    {
      clickedFolder,
      title,
      description,
      clickedMenu,
      children,
      isepisode,
      orderNumber,
    },
    ref
  ) => {
    return (
      <div
        ref={ref}
        className="relative bg-white border border-primary-300 rounded-md p-4 cursor-pointer hover:border-primary-500 hover:shadow-md "
        onClick={clickedFolder}
      >
        <div className="flex items-center justify-between">
          <div className="flex items-center">
            {isepisode ? (
              <FlimIcon className="size-8 mr-3 text-primary-500" />
            ) : (
              <FolderIcon className="size-8 mr-3 text-primary-500" />
            )}
            <div>
              <span className="text-md font-medium text-gray-900">{title}</span>
              <p className="text-xs text-gray-600">{description}</p>
            </div>
          </div>
          <div className="">
            <CustomTooltip title={`Edit ${title}`} placement="bottom">
              <button
                onClick={clickedMenu}
                className=" text-primary-400 hover:text-gray-700 p-1 hover:rounded-full hover:bg-primary-100"
              >
                <EllipsisVerticalIcon />
              </button>
            </CustomTooltip>
            <div className="absolute right-1 top-16 mt-2 bg-white border border-gray-200 rounded-md shadow-md z-10">
              {children}
            </div>
          </div>
        </div>
        <div className="absolute top-0 px-1 left-0 bg-primary-50 text-[12px] rounded-l-md">
          {orderNumber && <strong>{orderNumber}</strong>}
        </div>
      </div>
    );
  }
);
export default FolderCard;
